export const authConfig = {
  clientId: process.env.REACT_APP_SSO_CLIENT_ID,
  authority: process.env.REACT_APP_SSO_AUTHORITY,
  redirectUri: process.env.REACT_APP_SSO_REDIRECT_URI,
  apiClientId: process.env.REACT_APP_API_SSO_CLIENT_ID,
};
